<template>
  <div>
    <!-- Add a bold button -->
    <button class="ql-bold">Bold</button>
    <button class="ql-italic">Italic</button>
    <button class="ql-underline">Underline</button>
    <button class="ql-strike">Strike</button>
    <button class="ql-list" value="ordered">Numbering</button>
    <button class="ql-list" value="bullet">Bullet</button>
    <!-- Add font size dropdown -->
    <select class="ql-size">
      <option value="small"></option>
      <!-- Note a missing, thus falsy value, is used to reset to default -->
      <option selected></option>
      <option value="large"></option>
      <option value="huge"></option>
    </select>

    <!-- <select class="ql-font">
                    <option selected="selected"></option>
                    <option value="serif"></option>
                    <option value="monospace"></option>
    </select>-->

    <!-- Add subscript and superscript buttons -->
    <button class="ql-script" value="sub"></button>
    <button class="ql-script" value="super"></button>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      userAuth: JSON.parse(localStorage.getItem('user')),
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        }
      },
      content: `...`,
    }
  },
  components: {
    quillEditor,

  },

}
</script>
